export default "__VITE_ASSET__Dvikmd1X__";